document.addEventListener('DOMContentLoaded', function() {
  var botaoCheckout = document.querySelector('.cart__checkout-button.button');
  var formCarrinho = document.querySelector('#cart-form');

  if (!botaoCheckout || !formCarrinho) {
    console.warn('Botão de checkout ou formulário não encontrados');
    return;
  }

  function desabilitaBotao() {
    botaoCheckout.setAttribute('disabled', 'disabled');
    botaoCheckout.style.opacity = "0.5";
    botaoCheckout.style.cursor = "not-allowed";
  }

  function habilitaBotao() {
    botaoCheckout.removeAttribute('disabled');
    botaoCheckout.style.opacity = "";
    botaoCheckout.style.cursor = "";
  }

  function formatarData(isoDate) {
    if (!isoDate) return '';
    var partes = isoDate.split('-');
    if (partes.length !== 3) return isoDate;
    return partes[2] + '/' + partes[1] + '/' + partes[0];
  }

  function limparPropriedadesAntigas() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (!cart.items.length) {
          console.warn('Carrinho vazio, não há propriedades para limpar.');
          return;
        }

        var primeiraLinha = cart.items[0];

        if (primeiraLinha.properties && 
            (primeiraLinha.properties['Tipo de Entrega'] || 
             primeiraLinha.properties['Data de Entrega'] || 
             primeiraLinha.properties['Horário de Entrega'])) {

          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: primeiraLinha.key,
              quantity: primeiraLinha.quantity,
              properties: {
                'Tipo de Entrega': '',
                'Data de Entrega': '',
                'Horário de Entrega': ''
              }
            })
          })
          .then(r => r.json())
          .then(data => {
            console.log('Propriedades antigas removidas');
            return data;
          });
        }
      })
      .catch(err => console.error('Erro ao limpar propriedades:', err));
  }

  function salvarProperties(tipo, data, hora) {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (!cart.items.length) {
          console.warn('Carrinho vazio, não foi possível salvar propriedades.');
          return;
        }

        var primeiraLinha = cart.items[0].key;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: primeiraLinha,
            quantity: cart.items[0].quantity,
            properties: {
              'Tipo de Entrega': tipo || '',
              'Data de Entrega': data || '',
              'Horário de Entrega': hora || ''
            }
          })
        })
        .then(r => r.json())
        .then(data => {
          console.log('Propriedades salvas no primeiro item:', {
            tipo: tipo,
            data: data,
            hora: hora
          });
          return data;
        })
        .catch(err => {
          console.error('Erro ao salvar propriedades:', err);
          throw err;
        });
      });
  }

  limparPropriedadesAntigas();
  desabilitaBotao();

  var salvandoPropriedades = false;

  formCarrinho.addEventListener('submit', function(e) {
    var tipo = formCarrinho.dataset.tipo;
    var data = formCarrinho.dataset.data;
    var hora = formCarrinho.dataset.hora;

    if ((tipo || data || hora) && !salvandoPropriedades) {
      e.preventDefault();
      salvandoPropriedades = true;

      salvarProperties(tipo, data, hora)
        .then(function() {
          formCarrinho.submit();
        })
        .catch(function(err) {
          console.error('Erro ao processar checkout:', err);
          salvandoPropriedades = false;
          alert('Erro ao processar pedido. Por favor, tente novamente.');
        });
    }
  });

  window.ZapietEvent.listen('checkoutEnabled', function(params) {
    if (params.method === "shipping") {
      habilitaBotao();
    } else if (params.time && params.time.length > 0) {
      habilitaBotao();

      var tipo = params.method === 'delivery' ? 'Entrega' : 'Retirada';
      var dataFormatada = formatarData(params.date);

      formCarrinho.dataset.tipo = tipo;
      formCarrinho.dataset.data = dataFormatada;
      formCarrinho.dataset.hora = params.time;

      console.log('Dados do Zapiet prontos para checkout:', {
        tipo: tipo,
        data: dataFormatada,
        hora: params.time
      });
    } else {
      desabilitaBotao();
      delete formCarrinho.dataset.tipo;
      delete formCarrinho.dataset.data;
      delete formCarrinho.dataset.hora;
    }
  });

  window.ZapietEvent.listen("selected_method", function(checkout_method) { 
    switch (checkout_method) { 
      case "pickup": 
      case "delivery": 
        desabilitaBotao();
        delete formCarrinho.dataset.tipo;
        delete formCarrinho.dataset.data;
        delete formCarrinho.dataset.hora;
        break; 
      case "shipping": 
        habilitaBotao();
        break; 
    }
  });

  window.ZapietEvent.listen('delivery.timepicker.rendered', function() {
    if (window.Zapiet.Widget.checkoutEnabled && window.Zapiet.Widget.checkoutEnabled().time) {
      habilitaBotao();
    }
  });

});
